import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotfoundComponent } from "./error/page-notfound.component";
import { AdminGuard } from 'src/app/guards/admin/admin.guard';
import { Role } from './interface/roles/roles.interface'; // Importa o enum de roles

const routes: Routes = [
  { path: '', redirectTo: 'pages', pathMatch: 'full' },
  {
    path: 'account',
    loadChildren: () => import('./account/account.module').then((m) => m.AccountModule)
  },
  {
    path: 'pages',
    canActivate: [AdminGuard],
    data: {
      roles: [
        Role.MASTER,
        Role.SUPERUSER,
        Role.EDITAR_PROJETO,
        Role.EDITAR_REPOSITORIO,
        Role.FORESTOKEN
      ]
    },
    loadChildren: () => import('./pages/pages.routes').then((m) => m.PAGES_ROUTES),
  },
  {
    path: '404',
    component: PageNotfoundComponent
  },
  {
    path: "**",
    redirectTo: "/404"
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
